export default __webpack_public_path__ + "static/media/amiens.3008d794.jpg";